import { useTranslation } from "react-i18next";
import { HERO_IMAGE, WHATSAPP_LINK } from "@/mocks/restaurant";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="top" className="relative flex min-h-[100svh] w-full items-center">
      <div className="absolute inset-0 h-full w-full">
        <img
          src={HERO_IMAGE}
          alt={t("hero.imageAlt")}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/95" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-5 pb-28 pt-32 md:px-10 md:py-40">
        <p className="font-body text-[11px] uppercase tracking-[0.35em] text-secondary-500 md:text-xs">
          {t("hero.eyebrow")}
        </p>
        <h1 className="mt-5 font-heading text-4xl leading-[1.1] text-foreground-50 md:text-6xl">
          {t("hero.title")}
        </h1>
        <p className="mt-5 max-w-xl font-body text-base leading-relaxed text-secondary-500 md:text-lg">
          {t("hero.paragraph")}
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="press inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 font-body text-base text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer sm:w-auto"
          >
            <i className="ri-whatsapp-fill text-xl" aria-hidden="true" />
            {t("hero.ctaWhatsapp")}
          </a>
          <a
            href="#como-llegar"
            className="press inline-flex min-h-[48px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500 bg-transparent px-7 py-3.5 font-body text-base text-primary-500 transition-colors hover:bg-primary-500/10 cursor-pointer sm:w-auto"
          >
            {t("hero.ctaDirections")}
          </a>
        </div>

        <p className="mt-8 font-body text-xs tracking-wide text-secondary-500/90 md:text-sm">
          {t("hero.bottomLine")}
        </p>
      </div>
    </section>
  );
}